export type KitTranslateFn = (key: string, fallback?: string) => string;

export function kitT(
    translate: KitTranslateFn | undefined,
    key: string,
    fallback: string
): string {
    if (translate) {
        return translate(key, fallback);
    }
    return fallback;
}
